import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { EntryLoader } from "../../components/loader";
import { LayoutForNoting } from "../../components/layout";
import { isLocal, isDev } from "@cores/enviromentExtension";
import Cookies from "js-cookie";
import {sessionKeeper} from "@cores/sessionKeeper";

// LX Hausys Tiptop에서 앱을 클릭해서 들어오게 될 때 호출되는 페이지
class InitiateLXHausys extends React.Component {
    trySetBeforeLoginUrl() {
        try {
            const search = location.search;
            const params = search?.replace("?", "").split("&");
            if(!params || params.length  === 0) {
                return;
            }
            for(const param of params) {
                const [key, value] = param.split("=");
                if (key === "mode" && value === "library") {
                    const domain = sessionKeeper.getDomain();
                    Cookies.set("beforeLogin", `/library/spaces`, {
                        expires: 1,
                        path: "/",
                        domain,
                    });
                }
                else if (key === "projectId" && value) {
                    const domain = sessionKeeper.getDomain();
                    Cookies.set("entryTarget", JSON.stringify({
                        spaceId: "lxhausys",
                        projectId: value,
                    }), {
                        expires: 1,
                        path: "/",
                        domain,
                    });
                }
            }
        } catch(e) {
            // ignored
        }
    }
    componentDidMount() {
        this.trySetBeforeLoginUrl();
        if(isLocal || isDev) {
            window.location.href = "https://sx7bqjcob9.execute-api.ap-northeast-2.amazonaws.com/dev/saml/lx-hausys-saml/login";
        } else {
            window.location.href = "https://6bwtugkol6.execute-api.ap-northeast-2.amazonaws.com/lxhausys/saml/lx-hausys-saml/login"
        }
    }

    render() {
        return (
            <LayoutForNoting>
                <EntryLoader />
            </LayoutForNoting>
        );
    }
}
let mapStateToProps = (state) => {
    return {};
};
let mapDispatchToProps = (dispatch) => {
    return {};
};

InitiateLXHausys = connect(mapStateToProps, mapDispatchToProps)(InitiateLXHausys);
export default withRouter(InitiateLXHausys);
